import { render, staticRenderFns } from "./PersonalizedGameResetPackage.vue?vue&type=template&id=1f5216ee&scoped=true&"
import script from "./PersonalizedGameResetPackage.vue?vue&type=script&lang=js&"
export * from "./PersonalizedGameResetPackage.vue?vue&type=script&lang=js&"
import style0 from "./PersonalizedGameResetPackage.vue?vue&type=style&index=0&id=1f5216ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f5216ee",
  null
  
)

export default component.exports